import React from "react";
import { Grid } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import UiSelect from "../../../_uiComponents/UiSelect";
import UiInput from "../../../_uiComponents/UiInput";
import { UiInputGroupWr } from "../../../../_uiComponents/common/form/UiInputComponents";
import UiDateRangePicker from "../../../_uiComponents/UiDateRangePicker";
import UiFileUploader from "../../../../_uiComponents/common/form/UiFileUploader";
import { UiButton } from "../../../../_uiComponents/common/form/UiButton";


export default function CreateNewsFeedForm(props) {
     const [character, setCharacter] = React.useState("");
     const handleChangeSelect = (event) => {
          setCharacter(event.target.value);
     };
     const options = [
          { value: "value-1", label: "text-1" },
          { value: "value-2", label: "text-2" },
          { value: "value-3", label: "text-3" },
     ];

     return (
          <>
               <UiInputGroupWr
                    title="Create News Feed">

                         <Grid
                            container
                            spacing={2}
                         >
                         <Grid
                              item
                              xs={12}
                              lg={6}

                         >
                              <UiInput
                                   type="text"
                                   label="Title"
                              />
                         </Grid>
                        </Grid>
                         <Grid
                              container
                              spacing={2}
                         >
                              <Grid
                                   item
                                   xs={12}
                                   lg={6}
                                   className="sba-search-input"
                              >
                                   <UiInput
                                        label="Description"
                                        multiline={
                                             true
                                        }
                                        minRows={
                                             3
                                        }
                                        maxRows={
                                             5
                                        }
                                   />
                              </Grid>
                         </Grid>
                        <Grid
                            container
                            spacing={2} >

                            <Grid
                                item
                                xs={12}
                                lg={6}

                            >
                                <div className="sba-date-range-picker">
                                    <UiDateRangePicker />
                                </div>
                              </Grid>
                              </Grid>
                              <div className="sba-newsfeed-file-upload">
                              <Grid container>
                        <Grid item xs={12} md={8} lg={6}>
                            <UiFileUploader preview={true}/>
                        </Grid>
                        </Grid>
                        </div>
                              <Grid
                                   container
                                   spacing={2}
                              >
                                   <Grid
                                        item
                                        xs={12}
                                        lg={6}
                                        className="sba-search-input"
                                   >
                                        <UiSelect
                                             label="Select Template"
                                             value={
                                                  character
                                             }
                                             handleChange={
                                                  handleChangeSelect
                                             }
                                             options={
                                                  options
                                             }
                                        />  
                                   </Grid>
                              </Grid>                           
               </UiInputGroupWr>
               <div className="sba-campaign-content-button">
                <UiButton
                    name="Clear"
                    variant="outlined"
                    size="large"
                />
                <UiButton
                    name="Save"
                    variant="contained"
                    size="large"
                />
            </div>
          </>
     )
};
